// extracted by mini-css-extract-plugin
module.exports = {"body":"_3nZVDSNv","head":"_4ZR6I_Wr"};